<template>
    <sa-page-layout slot="table-body" :btnConfigurazioniVisible="btnConfigurazioniVisible" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :showModalLoading="showModalLoading" :linkConfigurazioni="linkConfigurazioni">
        <template slot="toolbar">
            <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm" @click="onClickNuovaDocumentoArticolo">
                <b-icon icon="plus"></b-icon>
                Nuovo
            </b-button>
        </template>
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info"> {{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <magazzino-tipo-documento-list-component ref="cmpMagazzinoDocumentoList"></magazzino-tipo-documento-list-component>
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import MagazzinoTipoDocumentoListComponent from "../components/MagazzinoTipoDocumentoListComponent.vue";
export default {
    components: { SaPageLayout, MagazzinoTipoDocumentoListComponent },
    data() {
        return {
            filtroTipoDocumento: {
                codiceAzienda: null,
                categoria: null,
            },
            btnNewVisible: false,
            btnConfigurazioniVisible: true,
            pathResource: "/magazzinoarticolicategorie",
            linkConfigurazioni: "/configurazionemagazzino",
            showModalLoading: false,
        };
    },
    computed: {},
    mounted() {
        let me = this;
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.$refs.cmpMagazzinoDocumentoList.loadDataDocumento();
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroTipoDocumento"] = JSON.stringify(me.filtroTipoDocumento);
            me.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onReset() {
            let me = this;
            me.filtroTipoDocumento = {
                codiceAzienda: null,
                categoria: null,
                note: null,
            };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroTipoDocumento"] = JSON.stringify(me.filtroTipoDocumento);
            me.loadData();
        },
        onClickNuovaDocumentoArticolo() {
            let me = this;
            me.$refs.cmpMagazzinoDocumentoList.onNuovoDocumentoArticolo();
        },
        onUpdateFilter(filterData) {
            let me = this;
            me.filtroTipoDocumento = filterData;
        },
    },
};
</script>
